import PropTypes from 'prop-types';
import React from 'react';
import { useRouter } from 'next/router';
import StyledCuratedExhibitionSubHeadline from './curatedExhibitionSubHeadline.style';
import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';

const CuratedExhibitionTeasers = ({ headline }) => {
  const router = useRouter();
  return (
    <StyledCuratedExhibitionSubHeadline
      isDarkPage={router.pathname.includes('exhibition') || router.pathname.includes('ausstellung')}
    >
      <Container className="curatedExhibitionSubHeadline__text-container">
        <Headline tag="h2">{headline}</Headline>
      </Container>
    </StyledCuratedExhibitionSubHeadline>
  );
};

CuratedExhibitionTeasers.propTypes = {
  headline: PropTypes.string
};

export default CuratedExhibitionTeasers;
